<template>
  <div class="container-fluid min-vh-100">
    <div class="row d-flex justify-content-center align-items-center min-vh-100">
      <div class="col-12 col-md-4 col-lg-3 bg-white">
        <div class="text-center mb-4">
          <img class="w-50" src="../../assets/img/rm-logo.svg" alt="RestMonster logotype">
          <h4 class="text-center mt-2">{{ $t('auth.accountCreated') }}</h4>
          <p class="text-danger">{{ $t('auth.accountCreatedText') }}</p>
        </div>
        <div class="mb-3 d-block d-flex justify-content-center">
<!--          <button @click="$router.push('/signin')" class="btn btn-outline-dark">{{ $t('auth.btn.login') }}</button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckInSuccess"
}
</script>

<style scoped>

</style>
